import { useLayoutElements } from 'contexts/LayoutElementsContext/useLayoutElements';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import React from 'react';
import { AssessmentsMobileHeader } from './AssessmentsMobileHeader';
import { AssessmentsDesktopHeader } from './AssessmentsDesktopHeader';
import { AssessmentsHeaderProps } from './types';

export const AssessmentsHeader = (props: AssessmentsHeaderProps) => {
  const { isMobile, isDesktop } = useDeviceType();
  const { isLeftModalOpen, isTaskModalExpanded } = useLayoutElements();

  const isMinimizedInModal = isDesktop && isLeftModalOpen && !isTaskModalExpanded;

  if (isMobile || isMinimizedInModal) {
    return <AssessmentsMobileHeader {...props} hasTopBorder={isMinimizedInModal} />;
  }

  return <AssessmentsDesktopHeader {...props} />;
};
